import React from 'react';
import PropTypes from 'prop-types';

import { Pre, Wrapper } from './Styled';

const JsonViewer = ({json, id}) => {

    return (
        <Wrapper>
            <span>Response</span>
            <Pre id={id} className="pt-3">
                {json}
            </Pre>
        </Wrapper>
    )
}

JsonViewer.propTypes = {
    json: PropTypes.string,
    id: PropTypes.string,
}

export default JsonViewer;



// WEBPACK FOOTER //
// ./src/components/JsonViewer/JsonViewer.js